import { format, isThisWeek, isThisYear, isToday } from 'date-fns';

export function formatContextualDate(date: Date): string {
  if (isToday(date)) {
    return format(date, 'HH:mm');
  } else if (isThisWeek(date, { weekStartsOn: 1 })) {
    // Monday-started week to match the rest of the app (getWeekDates etc.).
    return format(date, 'EEE'); // Mon-Sun
  } else if (isThisYear(date)) {
    return format(date, 'dd MMM'); // Date and month
  } else {
    return format(date, 'dd MMM yyyy'); // Date, month, and year
  }
}
